import { axiosInstance } from "./axiosConfig";
import { isAxiosError } from "axios";


interface DoctorAppointmentRequest {
  policy_number: string;
  full_name: string;
  birth_date: string;
  phone_number: string;
  email: string;
  complaint: string;
  appointment_date: string;
  hospital_chooser: "SELF" | string;
  doctor_name?: string;
  status: "PENDING" | string;
  user: number;
  hospital: number;
  platform: "WEB" ;
}

// INTERFACE_DoctorAppointment_SUCCESS_RESPONSE
interface DoctorAppointmentSuccessResponse {
  id?: number;
  policy_number: string;
  full_name: string;
  birth_date: string;
  phone_number: string;
  email: string;
  complaint: string;
  appointment_date: string;
  hospital_chooser: string;
  doctor_name?: string;
  status: string;
  user: number;
  hospital: number;
  platform: string;
  message?: string;
  created_at?: string;
}

// VALIDATION_ERROR
interface ErrorDetail {
  code: string;
  detail: string;
  attr: string;
}

// GENERIC_ERROR_RESPONSE
interface GenericErrorResponse {
  error?: string;
}

// INTERFACE_ERROR_RESPONSE
interface DoctorAppointmentErrorResponse {
  type: 'validation_error';
  errors: ErrorDetail[];
}

// INTERFACE_RESULT
interface DoctorAppointmentResult {
  data: DoctorAppointmentSuccessResponse | DoctorAppointmentErrorResponse | GenericErrorResponse;
  status: number;
}

// POST DoctorAppointment API
export const DoctorAppointment = async (
  requestData: DoctorAppointmentRequest,
  language: 'az' | 'en' = 'az'
): Promise<DoctorAppointmentResult> => {
  try {
    const response = await axiosInstance.post<DoctorAppointmentSuccessResponse>(
      '/health/doctor_appointment',
      requestData,
      {
        headers: {
          'Accept-Language': language,
          'Content-Type': 'application/json'
        }
      }
    );

    return {
      data: response.data,
      status: response.status
    };

  } catch (error) {
    if (isAxiosError(error)) {
      // HTTP ERROR with response
      if (error.response) {
        return {
          data: error.response.data || { error: 'Bilinməyən xəta baş verdi' },
          status: error.response.status
        };
      }

      // Network error - no response received
      if (error.request) {
        return {
          data: { error: 'Şəbəkə xətası - cavab alınmadı' },
          status: 0
        };
      }
    }

    // Generic error
    return {
      data: {
        error: error instanceof Error ? error.message : 'Gözlənilməz xəta baş verdi'
      },
      status: -1
    };
  }
};